import { createAsyncTypes } from 'utils/ActionCreator'

export const LANGUAGES_REQUEST_ASYNC = createAsyncTypes(
  'LANGUAGES_REQUEST_ASYNC',
  'Settings/Language'
)
export const UPDATE_LANGUAGES_ASYNC = createAsyncTypes(
  'UPDATE_LANGUAGES_ASYNC',
  'Settings/Language'
)
export const TAGS_AND_SEGMENTS_REQUEST_ASYNC = createAsyncTypes(
  'TAGS_AND_SEGMENTS_REQUEST_ASYNC',
  'Settings/Language'
)

export const SET_TAGS_AND_SEGMENTS_SEARCH = 'Settings/Language/SET_TAGS_AND_SEGMENTS_SEARCH'
export const SET_TAGS_AND_SEGMENTS_PAGE = 'Settings/Language/SET_TAGS_AND_SEGMENTS_PAGE'

export const DEFAULT_LANGUAGE_CHANGE = 'Settings/Language/DEFAULT_LANGUAGE_CHANGE'
export const LANGUAGE_TOGGLE = 'Settings/Language/LANGUAGE_TOGGLE'
export const ASSOCIATE_CHANGE = 'Settings/Language/ASSOCIATE_CHANGE'

export const SAVE_LANGUAGE_FROM_TAGS_TOGGLE = 'Settings/Language/SAVE_LANGUAGE_FROM_TAGS_TOGGLE'

export const NUM_FOR_DISTINGUISH_TAGS_AND_SEGMENTS = 5000000000000000
